import { POS_SUBSCRIPTION_STATUS, POS_SUBSCRIPTION_URGENT_DAYS } from '../constants/posConst';
import '../css/PosSubscription.css';

/**
 * A small coloured label saying where a subscription stands.
 *
 * @param {object} props
 * @param {string} props.status - one of POS_SUBSCRIPTION_STATUS
 * @param {number|null} [props.daysLeft] - from getSubscriptionState
 * @returns {JSX.Element|null}
 */
function PosSubscriptionStatusPill({ status, daysLeft = null }) {
  switch (status) {
    case POS_SUBSCRIPTION_STATUS.ACTIVE:
      return <span className="ps-pill ps-pill-ok">Active · {daysLeft} days left</span>;
    case POS_SUBSCRIPTION_STATUS.EXPIRING:
      return (
        // Red under POS_SUBSCRIPTION_URGENT_DAYS, matching the till's banner.
        <span className={`ps-pill ${daysLeft < POS_SUBSCRIPTION_URGENT_DAYS ? 'ps-pill-bad' : 'ps-pill-warn'}`}>
          {daysLeft === 0 ? 'Ends today' : `Ends in ${daysLeft} day${daysLeft === 1 ? '' : 's'}`}
        </span>
      );
    case POS_SUBSCRIPTION_STATUS.EXPIRED:
      return <span className="ps-pill ps-pill-bad">Expired</span>;
    case POS_SUBSCRIPTION_STATUS.SCHEDULED:
      return <span className="ps-pill ps-pill-muted">Not started yet</span>;
    default:
      return <span className="ps-pill ps-pill-muted">No subscription</span>;
  }
}

export default PosSubscriptionStatusPill;
